import { msalInstance, loginRequest } from "../authConfig";

import store from "@/store/index";

export function registerGuard(router: any) {
  router.beforeEach(async (to: any, from: any, next: any) => {
    document.title = to?.meta?.headerName || "Bygg Trysilhus";
    if (to.meta?.notRequiresAuth) {
      const redirect = await localStorage.getItem("btLogin");
      if (redirect) {
        router.push(redirect);
        await localStorage.setItem("btLogin", "");
      } else {
        if (to.name === "Startpage") {
          const isAuthenticated = await isUserAuthenticated();
          if (isAuthenticated) {
            router.push({ name: "Dashboard" });
          }
        }
        next();
      }
    } else {
      const isAuthenticated = await isUserAuthenticated();
      if (!isAuthenticated) {
        if (to.name === "Kiosk") {
          next();
        } else if (from.name === "Startpage") {
          login(to.fullPath);
        } else {
          router.push({ name: "Startpage" });
        }
      } else {
        if (isAuthenticated && store.getters["shared/profile"] === null) {
          await store.dispatch(
            "shared/setLoadingText",
            "Vennligst vent.. profilen din lastes inn"
          );
          await store.dispatch("shared/setProfile");
        }

        // const isTrysilhus = await store.getters["shared/isTrysilhus"];
        //Route is only for trysilhus
        // if (to.meta?.onlyTrysilhus && !isTrysilhus) {
        //   notifications.warn(`Du har ikke tilgang til ${to?.meta?.headerName}`);
        //   router.push({ name: "Dashboard" });
        // }
        next();
      }
    }
  });
}

export async function isUserAuthenticated(): Promise<boolean> {
  // If your application uses redirects for interaction, handleRedirectPromise must be called and awaited on each page load before determining if a user is signed in or not
  const res = msalInstance
    .handleRedirectPromise()
    .then(async () => {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const request = {
          ...loginRequest,
          account: accounts[0],
        };
        const result = await msalInstance.acquireTokenSilent(request);
        //Save token to api call
        if (result.idToken) {
          const tokenId = "msal." + process.env.VUE_APP_CLIENTID + ".idtoken";
          localStorage.setItem(tokenId, result.idToken);
          //save MSAL account to logout
          msalInstance.setActiveAccount(result.account);

          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    })
    .catch(() => {
      return false;
    });

  return res;
}

export async function login(routeFullPath): Promise<boolean> {
  const request = {
    ...loginRequest,
    redirectStartPage: routeFullPath,
  } as any;

  if (store.getters["shared/isKiosk"]) {
    request.prompt = "login";
  }

  const res = msalInstance
    .handleRedirectPromise()
    .then(async () => {
      return msalInstance
        .loginRedirect(request)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    })
    .catch(() => {
      return false;
    });

  return res;
}

export async function getToken(): Promise<string> {
  const account = msalInstance.getActiveAccount();

  if (account) {
    const request = {
      scopes: ["User.Read"],
      account: account,
    };
    const result = await msalInstance.acquireTokenSilent(request);
    return result?.idToken;
  }

  return "";
}
